import { Routes, Route } from 'react-router'
import Home from './Home/Home'
import NotFound from './NotFound/NotFound'
import Meta from '@components/Meta/Meta'
import Privacy from './Privacy/Privacy'
// import Digital from './Digital/Digital'

export default function App() {
  return (
    <>
      <Meta />
      <Routes>
        <Route path="/" element={<Home />} index />
        {/* <Route path="/kit-espacio-datos" element={<Digital />} /> */}
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  )
}
